import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, OnChanges } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TradingViewChartBase } from '@zero/shared/charts/ui-charts-base';
import { EqualsInstrumentTypePipe, IncludesPipe } from '@zero/shared/ui-pipes';
import { IconComponent, PillComponent } from '@zero/shared/ui-web-design-system';
import { ChartSerieType, InstrumentType } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { LoadingIndicatorWebComponent } from '../loading-indicator-web/loading-indicator-web.component';
import { SettingsWebComponent } from '../settings-web/settings-web.component';

@Component({
  selector: 'charts-web-trading-view-chart',
  templateUrl: './trading-view-chart-web.component.html',
  styleUrls: ['./trading-view-chart-web.component.scss'],
  imports: [
    SettingsWebComponent,
    LoadingIndicatorWebComponent,
    TranslocoPipe,
    IconComponent,
    IncludesPipe,
    EqualsInstrumentTypePipe,
    PillComponent,
    NgClass,
    NgbTooltipModule,
    NgTemplateOutlet,
  ],
})
export class TradingViewChartWebComponent extends TradingViewChartBase implements AfterViewInit, OnChanges {
  public readonly InstrumentType = InstrumentType;

  public toggleSerie(type: ChartSerieType): void {
    const currentSeries = new Set(this.model.currentSeries);
    const isLast = type === 'last';
    if (isLast && currentSeries.has('last')) {
      return;
    }

    if (currentSeries.has(type)) {
      currentSeries.delete(type);
    } else {
      currentSeries.add(type);
      if (isLast) {
        currentSeries.delete('bid');
        currentSeries.delete('ask');
      } else {
        currentSeries.delete('last');
      }
    }

    if (currentSeries.size === 0) {
      currentSeries.add('last');
    }

    this.model.currentSeries = Array.from(currentSeries);
    this.chartService.toggleSerie(this.model.currentSeries);
  }

  public openProChart() {
    const host = environment.local ? `http://${window.location.host}` : environment.assetshost;
    const file = environment.isTest ? 'index.t.html' : 'index.p.html';
    window.open(`${host}/assets/html/pro-chart/${file}?isin=${this.model.isin}`, '', 'popup');
  }
}
